import(/* webpackMode: "eager" */ "/app/src/app/(public)/purchase-guide/page.tsx");
